var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6743_103268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 24.3008C19.5962 24.3008 24.9688 18.9282 24.9688 12.3008C24.9688 5.67336 19.5962 0.300781 12.9688 0.300781C6.34133 0.300781 0.96875 5.67336 0.96875 12.3008C0.96875 18.9282 6.34133 24.3008 12.9688 24.3008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4453 12.3023H24.967C24.967 11.2192 24.8227 10.17 24.5536 9.17188H12.4453V12.3023Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4453 6.04061H23.2058C22.4712 4.84192 21.5319 3.78241 20.4368 2.91016H12.4453V6.04061Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9698 24.3001C15.794 24.3001 18.3898 23.324 20.4396 21.6914H5.5C7.54984 23.324 10.1456 24.3001 12.9698 24.3001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7307 18.564H23.2081C23.7979 17.6017 24.2552 16.5499 24.556 15.4336H1.38281C1.68361 16.5499 2.14097 17.6017 2.7307 18.564Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52738 2.17475H7.62092L6.60373 2.91373L6.99228 4.10947L5.97514 3.37048L4.958 4.10947L5.29362 3.07648C4.39803 3.8225 3.61306 4.69653 2.96619 5.67041H3.31658L2.66909 6.1408C2.56822 6.30908 2.47147 6.48003 2.37875 6.65352L2.68794 7.60513L2.11109 7.18602C1.9677 7.48981 1.83655 7.80045 1.71866 8.11756L2.0593 9.16606H3.31658L2.29939 9.90505L2.68794 11.1008L1.6708 10.3618L1.06152 10.8045C1.00053 11.2947 0.96875 11.794 0.96875 12.3008H12.9688C12.9688 5.67341 12.9688 4.89209 12.9688 0.300781C10.5982 0.300781 8.38836 0.988438 6.52738 2.17475ZM6.99228 11.1008L5.97514 10.3618L4.958 11.1008L5.34655 9.90505L4.32936 9.16606H5.58664L5.97514 7.97033L6.36364 9.16606H7.62092L6.60373 9.90505L6.99228 11.1008ZM6.60373 6.40939L6.99228 7.60513L5.97514 6.86614L4.958 7.60513L5.34655 6.40939L4.32936 5.67041H5.58664L5.97514 4.47467L6.36364 5.67041H7.62092L6.60373 6.40939ZM11.2966 11.1008L10.2795 10.3618L9.26234 11.1008L9.65089 9.90505L8.6337 9.16606H9.89098L10.2795 7.97033L10.668 9.16606H11.9253L10.9081 9.90505L11.2966 11.1008ZM10.9081 6.40939L11.2966 7.60513L10.2795 6.86614L9.26234 7.60513L9.65089 6.40939L8.6337 5.67041H9.89098L10.2795 4.47467L10.668 5.67041H11.9253L10.9081 6.40939ZM10.9081 2.91373L11.2966 4.10947L10.2795 3.37048L9.26234 4.10947L9.65089 2.91373L8.6337 2.17475H9.89098L10.2795 0.979016L10.668 2.17475H11.9253L10.9081 2.91373Z",
    fill: "#0052B4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.46875,
    y: 0.800781,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E7EAEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6743_103268"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.96875,
    y: 0.300781,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUs);
export default __webpack_public_path__ + "static/media/flag-us.d6a0102b782973307c669f5e602b445d.svg";
export { ForwardRef as ReactComponent };